
import Vue from "vue";
import axios from "axios";
import { required, min } from "vee-validate/dist/rules";
import { ValidationObserver, extend } from "vee-validate";
import { KeyValuePairOfIntegerAndString, TaskFilter, TaskFilterCannedDates  } from "../../../types/Sapphire_dto";

extend("required", {
  ...required,
  message: "This field is required",
});
extend("min", {
  ...min,
  message: "This field must be more than 3 characters.",
});
const SaveTaskFilterPopup = Vue.extend({
  name: "save-task-filter-popup-component",
  data: function () {
    return {
      openPopup: false,
      taskFilter: new Object() as TaskFilter,
      isNameDisabled: false,
      presetDateOptions: [] as KeyValuePairOfIntegerAndString[],            
    };
  },
  methods: {
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    async showPopup(newFilterFLag: boolean) {
      const response = await axios.post("../../Common/Services/EhrTaskService.svc/GetTaskFilterCannedDates");
      this.presetDateOptions = JSON.parse(response.data.d);

      this.isNameDisabled = !newFilterFLag;
      this.openPopup = true;
      let temp: string = (<HTMLInputElement>(
        document.getElementById("hfTaskFilter")
      )).value;
      this.taskFilter = JSON.parse(temp);

      if (newFilterFLag) {
        this.taskFilter.TaskFilterID = 0;
        this.taskFilter.SavedName = "";
        this.taskFilter.SavedDescription = "";
        this.taskFilter.CannedDate = TaskFilterCannedDates.DefaultValue;
      } else {
        this.taskFilter.SavedName = this.taskFilter.SavedName.replaceAll(
          "(Default) - ",
          ""
        );
      }
    },
    hidePopup() {
      this.openPopup = false;
    },
    async onSaveClick() {
      let response = await axios.post(
        "../../Common/Services/EhrTaskService.svc/SaveTaskFilter",
        {
          taskFilter: JSON.stringify(this.taskFilter),
        }
      );
      this.taskFilter.TaskFilterID = JSON.parse(response.data.d);

      document.getElementById("btnTaskFilterUpdateButton").click();
      this.hidePopup();
    },
  },
});

export type SaveTaskFilterPopupRef = InstanceType<typeof SaveTaskFilterPopup>;
export default SaveTaskFilterPopup;
